import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import passportImg from '../../assets/img/passportLogo.svg'
import focusable from '../../components/Focusable/Focusable'
import { secondsToHms } from '../../../../shared/helpers.js'
import { store } from '../../store'

class Video extends React.PureComponent {
  constructor(props) {
    super(props)
    this.componentType = 'video'
    this.video = null

    this.state = {
      imageError: false,
      thumb:
        this.props.video.images['asset-mezzanine-16x9'] ||
        this.props.video.images['asset-kids-mezzanine1-16x9']
          ? this.props.video.images['asset-mezzanine-16x9'] ||
            this.props.video.images['asset-kids-mezzanine1-16x9']
          : undefined,
    }

    this.url = `/video-details/${encodeURIComponent(this.props.video.url)}`
    this.storeState = store.getState()
    this.videoLinkRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false

    if ('ENTER' === key) {
      this.videoLinkRef.current?.click()
    }

    return handled
  }

  setVideoRef(video) {
    if (video !== null) {
      this.video = video
    }
  }

  imgError(image) {
    image.persist()
    this.setState({ imageError: true, thumb: null })
  }

  render() {
    const { video, hasFocus } = this.props
    const season = video.parent.season
      ? video.parent.season.ordinal
      : video.parent.ordinal
    const episode = video.parent.season ? video.parent.ordinal : null
    const metadata = season
      ? `S${season} ${episode ? `Ep${episode}` : ''}`
      : null
    const formattedDuration =
      metadata && secondsToHms(video.duration)
        ? ` | ${secondsToHms(video.duration)}`
        : secondsToHms(video.duration)

    let hasImage = true
    const { thumb } = this.state
    if (thumb === null) {
      hasImage = false
    }

    let shouldDisplayTitle =
      !hasImage &&
      this.props.video.itemType !== 'season' &&
      this.props.video.itemType !== 'skylab-collection'

    return (
      <Link to={this.url} ref={this.videoLinkRef}>
        <div className={`video-container ${hasFocus ? 'focused' : ''}`}>
          <div className={`thumbnail-container`}>
            {hasImage ? (
              <img
                className="thumbnail-img"
                onError={(e) => this.imgError(e)}
                src={`${thumb}?resize=350x205&format=webp`}
              />
            ) : null}
            {video.flags && video.flags.is_mvod && (
              <div className="passport-triangle">
                <img
                  className="passport-logo"
                  src={passportImg}
                  alt={'passport logo'}
                />
              </div>
            )}
            {shouldDisplayTitle && (
              <div className="title-container">
                <span className="title">{video.title}</span>
              </div>
            )}
          </div>
          <div className="video-body" ref={(video) => this.setVideoRef(video)}>
            <h3 className="video-title">{video.title}</h3>
            <span className="video-details">
              {/* revisit this line is it even working?  */}
              {'full_length' !== video.video_type && `${video.video_type}: `}
              {metadata}
              {formattedDuration}
            </span>
            <p>{video.description_short}</p>
          </div>
        </div>
      </Link>
    )
  }
}

Video.propTypes = {
  hasFocus: PropTypes.bool,
  video: PropTypes.shape({
    description_short: PropTypes.string,
    duration: PropTypes.number,
    flags: PropTypes.shape({
      is_mvod: PropTypes.bool,
    }),
    images: PropTypes.object,
    itemType: PropTypes.string,
    parent: PropTypes.shape({
      ordinal: PropTypes.number,
      season: PropTypes.shape({
        ordinal: PropTypes.number,
      }),
    }),
    title: PropTypes.string,
    url: PropTypes.string,
    video_type: PropTypes.string,
  }),
}

export default focusable(Video)
